<template>
    <div class="bill-container">
        <div class="bill-header">
            <div class="bill-header-text">
                <div class="bill-header-title">Bill</div>
                <div class="bill-header-subtitle">Table №4</div>
            </div>
            <div class="bill-header-logo">
                <img :src="computedCompanyData.locale.logo"
                     :alt="`Logo of ${computedCompanyData.locale.name}`">
            </div>
        </div>

        <template v-if="testData">
            <div class="cart_list"
                 :class="{ 'multiple-orders': isMultipleComputedOrders }"
                 v-for="order in computedOrders"
                 :key="order.id">
                <ul v-if="isMultipleComputedOrders">
                    <li>
                        <ul>
                            <li v-for="orderItem in order.items"
                                :key="orderItem.id"
                                :class="{ hidden: getItemPrice(orderItem) <= 0 }">
                                <p>
                                    {{ orderItem.product.name }}
                                    <small>{{ `x ${getItemQuantity(orderItem)}` }}</small>
                                </p>
                                <em>
                                    {{ formatPrice(getItemPrice(orderItem)) }}
                                </em>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <CartBill :items="testData.items" />
            <!-- <div v-show="!isSplitBill">
                <CartBill :items="testData.items" />
                <CartPaid :items="testData.items" />
            </div>
            <div v-show="isSplitBill">
                <div class="bill-split-info">
                    <IconBase>
                        <IconSpoonFork />
                    </IconBase>
                    <span>Currently selecting items</span>
                </div>
                <CartSplitBill :items="testData.items" />
                <CartSplitBillGuest :items="testData.items" />
            </div> -->

            <!-- <VButton class="bill-split-button" type="bordered" height="short" @click="toggleSplitBill()">
                <span v-show="!isSplitBill">Split the bill</span>
                <span v-show="isSplitBill">Combine the bill</span>
            </VButton> -->
            <VButton type="dark-violet"
                     height="short">
                {{ getOrderButtonText() }}
            </VButton>
        </template>
        <template v-else>
            <div class="cart_plug">
                <img src="@/assets/img/cart/crying_cat.png"
                     alt=""
                     class="empty-cart-image">
                <p class="empty-cart-title">
                    {{ $t('pages.cart.emptyCartTitle') }}
                </p>
                <p class="empty-cart-message">
                    {{ $t('pages.cart.emptyCartMessage') }}
                </p>
            </div>
            <a class="btn cart_options default_button single-button"
               @click="goToHistory">{{ $t('pages.cart.showHistory') }}</a>
            <div class="cart_options"
                 @click="goToMenu">
                <VButton type="dark-violet">
                    {{ $t('pages.cart.returnToMenu') }}
                </VButton>
            </div>
        </template>
    </div>
</template>

<script>
import VButton from "@/components/ui/VButton.vue";
import CartBill from "./CartBill.vue";

export default {
    name: "CartTabText",
    components: {
        CartBill,
        VButton,
    },
    data() {
        return {
            isSplitBill: false,
        };
    },
    computed: {
        computedCompanyData: function () {
            return this.$store.getters['getCompanyData'];
        },
    },
    methods: {
        toggleSplitBill() {
            this.isSplitBill = !this.isSplitBill;
        },
        getOrderButtonText() {
            let text = this.$t('pages.cart.pay');
            if (this.$store.getters['getIsModeHOT']) {
                text = this.$t('pages.cart.continue');
            }
            else if (this.$store.getters['getIsModeQSR']) {
                text = this.$t('pages.cart.orderAndPay');
            }
            else if (this.$store.getters['getIsModeSOT']) {
                text = this.$t('pages.cart.order');
            }
            return text;
        },
        goToMenu() {
            this.$router.push({ name: 'menu' });
        },
        goToHistory() {
            this.$router.push({ name: 'history' });
        },
    }
};
</script>

<style lang="scss" scoped>
@import "src/scss/assets/variables";


.bill-container {
    padding: 0 16px 22px;

    background-color: $color_alabaster;
}

.bill-header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    padding: 10px 0;
    margin-bottom: 12px;

    &-logo {
        width: 235px;
        height: 66px;
        overflow: hidden;
        flex-shrink: 0;

        &>img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }

    &-text {
        position: relative;

        flex-grow: 1;
    }

    &-title {
        font-size: 32px;
        font-weight: 700;

        color: black;
    }

    &-subtitle {
        position: absolute;
    }
}

.bill-split-info {
    display: flex;

    padding: 12px 16px;
    margin-bottom: 12px;

    font-weight: 510;
    font-size: 14px;

    color: black;

    svg {
        margin-right: 4px;
    }
}

.bill-split-button {
    margin-bottom: 14px;
}

.cart_plug {
    text-align: center;
    height: 100%;
    padding-top: 25%;

    .empty-cart-title {
        padding: 10% 0 5% 0;
        font-size: 1.5rem;
        color: black;
    }
}

.cart_options {
    display: flex;
    flex-direction: column;
    gap: 14px;
    margin-top: auto;
    padding-bottom: 24px;


    &.default_button {
        color: #6466f1;
        text-decoration: underline;
        font-size: 1.2em;
        text-align: center;
        padding-bottom: 15px;
    }

    &.regulamin_text {
        text-decoration: unset;
        display: block;

        a {
            color: #6466f1;
            text-decoration: underline;
        }
    }
}
</style>